// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Tiptap = require("../../bindings/Tiptap.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let ReactRender = require("../../../reason/utils/ReactRender.bs.js");
let LinkSanitizer = require("../../../reason/utils/LinkSanitizer.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let Form__HelpLabel = require("../../../uikit/reason/atoms/Form/Form__HelpLabel.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let React$1 = require("@floating-ui/react");
let RichTextEditorV5Icons = require("./RichTextEditorV5Icons.bs.js");

let make = React.forwardRef((props, ref) => {
  let title = props.title;
  let state = props.state;
  let tmp;
  switch (state) {
    case "Active" :
      tmp = "text-sky-600";
      break;
    case "Inactive" :
      tmp = "text-gray-800";
      break;
    case "Disabled" :
      tmp = "text-gray-400 hover:bg-transparent";
      break;
  }
  return JsxRuntime.jsxs("button", {
    children: [
      JsxRuntime.jsx("span", {
        children: title,
        className: "sr-only"
      }),
      props.children
    ],
    ref: Stdlib_Option.map((ref == null) ? undefined : Primitive_option.some(ref), prim => prim),
    className: TailwindMerge.twMerge([
      "relative flex items-center bg-white px-3 py-2 font-semibold  hover:bg-gray-50",
      tmp,
      Stdlib_Option.getOr(props.className, "")
    ]),
    title: title,
    disabled: state === "Disabled",
    type: "button",
    onClick: props.onClick,
    onMouseDown: props.onMouseDown
  });
});

let IconButton = {
  make: make
};

function RichTextEditorV5$Toolbar$ItalicsButton(props) {
  let editor = props.editor;
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(RichTextEditorV5Icons.Italics.make, {
      className: "w-5 h-5"
    }),
    onClick: param => {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleItalic(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
    },
    state: Tiptap.Editor.isActive(editor, "italic") ? "Active" : "Inactive",
    title: "Italic",
    className: props.className
  });
}

let ItalicsButton = {
  make: RichTextEditorV5$Toolbar$ItalicsButton
};

function RichTextEditorV5$Toolbar$BoldButton(props) {
  let editor = props.editor;
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(RichTextEditorV5Icons.Bold.make, {
      className: "w-5 h-5"
    }),
    onClick: param => {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleBold(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
    },
    state: Tiptap.Editor.isActive(editor, "bold") ? "Active" : "Inactive",
    title: "Bold"
  });
}

let BoldButton = {
  make: RichTextEditorV5$Toolbar$BoldButton
};

function RichTextEditorV5$Toolbar$UnderlineButton(props) {
  let editor = props.editor;
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(RichTextEditorV5Icons.Underline.make, {
      className: "w-5 h-5"
    }),
    onClick: param => {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleUnderline(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
    },
    state: Tiptap.Editor.isActive(editor, "underline") ? "Active" : "Inactive",
    title: "Underline"
  });
}

let UnderlineButton = {
  make: RichTextEditorV5$Toolbar$UnderlineButton
};

function RichTextEditorV5$Toolbar$BulletListButton(props) {
  let editor = props.editor;
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(RichTextEditorV5Icons.BulletList.make, {
      className: "w-5 h-5"
    }),
    onClick: param => {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleBulletList(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
    },
    state: Tiptap.Editor.isActive(editor, "bulletList") ? "Active" : "Inactive",
    title: "Bullet list"
  });
}

let BulletListButton = {
  make: RichTextEditorV5$Toolbar$BulletListButton
};

function RichTextEditorV5$Toolbar$OrderedListButton(props) {
  let editor = props.editor;
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(RichTextEditorV5Icons.OrderedList.make, {
      className: "w-5 h-5"
    }),
    onClick: param => {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleOrderedList(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
    },
    state: Tiptap.Editor.isActive(editor, "orderedList") ? "Active" : "Inactive",
    title: "Ordered list"
  });
}

let OrderedListButton = {
  make: RichTextEditorV5$Toolbar$OrderedListButton
};

function RichTextEditorV5$Toolbar$LinkTool(props) {
  let editor = props.editor;
  let match = React.useState(() => false);
  let setOpen = match[1];
  let open_ = match[0];
  let match$1 = React.useState(() => "");
  let setUrl = match$1[1];
  let url = match$1[0];
  let inputRef = React.useRef(null);
  let match$2 = React$1.useFloating({
    open: open_,
    onOpenChange: v => setOpen(param => v),
    placement: "bottom-start",
    strategy: "fixed",
    middleware: [
      React$1.offset(8),
      React$1.flip({
        padding: 8
      }),
      React$1.shift({
        padding: 8,
        crossAxis: true
      })
    ]
  });
  let update = match$2.update;
  let context = match$2.context;
  let refs = match$2.refs;
  React.useEffect(() => {
    if (open_) {
      update();
    }
  }, [
    open_,
    update
  ]);
  React.useEffect(() => {
    if (open_) {
      requestAnimationFrame(() => {
        let domElement = inputRef.current;
        if (domElement == null) {
          return;
        }
        domElement.focus({
          preventScroll: true
        });
      });
    }
  }, [open_]);
  let match$3 = React$1.useInteractions([
    React$1.useDismiss(context, {
      outsidePress: true,
      escapeKey: true
    }),
    React$1.useRole(context, {
      role: "dialog"
    })
  ]);
  let applyLink = () => {
    let href = LinkSanitizer.makeLinksAbsolute(url.trim());
    if (href === "") {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.unsetLink(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
    } else {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.setLink(Tiptap.Commands.Chainable.extendMarkRange(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor)), "link"), {
        href: href,
        target: "_blank"
      }));
    }
    setOpen(param => false);
  };
  let tmp;
  if (open_) {
    let newrecord = {...match$3.getFloatingProps()};
    tmp = JsxRuntime.jsx(React$1.FloatingPortal, {
      children: JsxRuntime.jsx(React$1.FloatingFocusManager, {
        context: context,
        modal: false,
        returnFocus: true,
        children: JsxRuntime.jsx("div", (newrecord.style = match$2.floatingStyles, newrecord.className = "z-[9999] w-max max-w-[400px] rounded-xl border bg-white p-3 shadow-xl", newrecord.ref = Primitive_option.some(refs.setFloating), newrecord.children = JsxRuntime.jsxs("form", {
          children: [
            JsxRuntime.jsx(Form__Input.make, {
              labelText: "URL",
              placeholderText: "https://example.com",
              onChange: e => {
                let value = e.target.value;
                setUrl(param => value);
              },
              onKeyDown: e => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  return applyLink();
                }
              },
              inputMode: "url",
              inputRef: Primitive_option.some(inputRef)
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                  onClick: param => setOpen(param => false),
                  size: "small",
                  _type: "button",
                  children: "Cancel"
                }),
                JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  onClick: param => setOpen(param => false),
                  size: "small",
                  _type: "submit",
                  children: "Apply"
                })
              ],
              className: "flex justify-end gap-2"
            })
          ],
          className: "flex flex-col gap-2",
          onSubmit: e => {
            e.preventDefault();
            applyLink();
          }
        }), newrecord))
      })
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(make, {
        children: JsxRuntime.jsx(RichTextEditorV5Icons.Link.make, {
          className: "w-5 h-5"
        }),
        onMouseDown: e => {
          e.preventDefault();
          let state = Tiptap.Editor.state(editor);
          if (state.selection.empty) {
            return;
          }
          let attrs = Tiptap.Editor.getLinkAttributes(editor);
          setUrl(param => {
            if (attrs === undefined) {
              return "";
            }
            let href = attrs.href;
            if (href !== undefined) {
              return href;
            } else {
              return "";
            }
          });
          setOpen(param => true);
        },
        state: Tiptap.Editor.isActive(editor, "link") ? "Active" : "Inactive",
        title: "Link",
        ref: refs.setReference
      }),
      tmp
    ]
  });
}

let LinkTool = {
  make: RichTextEditorV5$Toolbar$LinkTool
};

function RichTextEditorV5$Toolbar$ClearLinkButton(props) {
  let editor = props.editor;
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(RichTextEditorV5Icons.BreakLink.make, {
      className: "h-5 w-5"
    }),
    onClick: param => {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.unsetLink(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
    },
    state: Tiptap.Editor.isActive(editor, "link") ? "Inactive" : "Disabled",
    title: "Unset link"
  });
}

let ClearLinkButton = {
  make: RichTextEditorV5$Toolbar$ClearLinkButton
};

function RichTextEditorV5$Toolbar$HeadingButton(props) {
  let level = props.level;
  let editor = props.editor;
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(RichTextEditorV5Icons.Heading.make, {
      className: "w-4 h-4"
    }),
    onClick: param => {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleHeading(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor)), {
        level: level
      }));
    },
    state: Tiptap.Editor.isHeadingActive(editor, {
      level: level
    }) ? "Active" : "Inactive",
    title: "Heading",
    className: props.className
  });
}

let HeadingButton = {
  make: RichTextEditorV5$Toolbar$HeadingButton
};

function getOptionLabel(option) {
  if (option === "h2") {
    return "Heading 2";
  } else if (option === "h3") {
    return "Heading 3";
  } else if (option === "normal") {
    return "Normal";
  } else {
    return "Heading 1";
  }
}

function getOptionValue(x) {
  return x;
}

let HeadingOption = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};

function RichTextEditorV5$Toolbar$HeadingDropdown(props) {
  let editor = props.editor;
  let currentLevel = Tiptap.Editor.isHeadingActive(editor, {
    level: 1
  }) ? 1 : (
      Tiptap.Editor.isHeadingActive(editor, {
        level: 2
      }) ? 2 : (
          Tiptap.Editor.isHeadingActive(editor, {
            level: 3
          }) ? 3 : undefined
        )
    );
  let tmp;
  if (currentLevel !== undefined) {
    switch (currentLevel) {
      case 1 :
        tmp = "h1";
        break;
      case 2 :
        tmp = "h2";
        break;
      case 3 :
        tmp = "h3";
        break;
      default:
        tmp = "normal";
    }
  } else {
    tmp = "normal";
  }
  return JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    onChange: v => Stdlib_Option.forEach(Stdlib_Option.flatMap(v, x => {
      if (x === "h2") {
        return 2;
      } else if (x === "h3") {
        return 3;
      } else if (x === "normal") {
        return currentLevel;
      } else {
        return 1;
      }
    }), x => {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleHeading(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor)), {
        level: x
      }));
    }),
    options: [
      "h1",
      "h2",
      "h3",
      "normal"
    ],
    value: tmp,
    classNames: {
      menu: param => "!rounded-b !border !border-zinc-200 !shadow-sm",
      control: param => "!border-none !border-0 !rounded-md",
      dropdownIndicator: param => "!pl-0",
      indicatorSeparator: param => "hidden"
    }
  });
}

let HeadingDropdown = {
  HeadingOption: HeadingOption,
  make: RichTextEditorV5$Toolbar$HeadingDropdown
};

function RichTextEditorV5$Toolbar(props) {
  let variant = props.variant;
  let editor = props.editor;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            variant === "default" ? JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(RichTextEditorV5$Toolbar$HeadingDropdown, {
                  editor: editor
                })
              }) : (
                variant === "withoutHeaders" ? null : JsxRuntime.jsx(RichTextEditorV5$Toolbar$HeadingButton, {
                    editor: editor,
                    level: 3,
                    className: "rounded-tl"
                  })
              ),
            JsxRuntime.jsx(RichTextEditorV5$Toolbar$ItalicsButton, {
              editor: editor,
              className: variant === "withoutHeaders" ? "rounded-tl" : undefined
            }),
            JsxRuntime.jsx(RichTextEditorV5$Toolbar$BoldButton, {
              editor: editor
            }),
            JsxRuntime.jsx(RichTextEditorV5$Toolbar$UnderlineButton, {
              editor: editor
            })
          ],
          className: "divide-x flex"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(RichTextEditorV5$Toolbar$BulletListButton, {
              editor: editor
            }),
            JsxRuntime.jsx(RichTextEditorV5$Toolbar$OrderedListButton, {
              editor: editor
            }),
            JsxRuntime.jsx(RichTextEditorV5$Toolbar$LinkTool, {
              editor: editor
            }),
            JsxRuntime.jsx(RichTextEditorV5$Toolbar$ClearLinkButton, {
              editor: editor
            })
          ],
          className: "divide-x flex"
        })
      ],
      className: "rounded-md divide-y flex flex-col sm:flex-row sm:divide-x sm:divide-y-0"
    }),
    className: "w-full border-b z-[2] relative"
  });
}

let Toolbar = {
  IconButton: IconButton,
  ItalicsButton: ItalicsButton,
  BoldButton: BoldButton,
  UnderlineButton: UnderlineButton,
  BulletListButton: BulletListButton,
  OrderedListButton: OrderedListButton,
  LinkTool: LinkTool,
  ClearLinkButton: ClearLinkButton,
  HeadingButton: HeadingButton,
  HeadingDropdown: HeadingDropdown,
  make: RichTextEditorV5$Toolbar
};

function getContent(editor) {
  let state = Tiptap.Editor.state(editor);
  if (state.doc.textContent.trim().length === 0) {
    return;
  } else {
    return Tiptap.Editor.getHTML(editor);
  }
}

function RichTextEditorV5(props) {
  let __proseStyle = props.proseStyle;
  let editorRef = props.editorRef;
  let id = props.id;
  let optionalText = props.optionalText;
  let status = props.status;
  let __height = props.height;
  let __toolbar = props.toolbar;
  let onChangeFull = props.onChangeFull;
  let onChange = props.onChange;
  let toolbar = __toolbar !== undefined ? __toolbar : "default";
  let height = __height !== undefined ? __height : "long";
  let proseStyle = __proseStyle !== undefined ? __proseStyle : "sm";
  let onUpdate = React.useCallback(param => {
    if (!param.transaction.docChanged) {
      return;
    }
    let editor = param.editor;
    Stdlib_Option.forEach(onChange, fn => fn(getContent(editor)));
    Stdlib_Option.forEach(onChangeFull, fn => {
      let content = getContent(editor);
      fn({
        content: content,
        editor: editor
      });
    });
  }, [
    onChange,
    onChangeFull
  ]);
  let editor = Tiptap.ReactTiptap.useEditor(Tiptap.Editor.Config.make(Stdlib_Option.getOr(props.initialContent, ""), onUpdate, props.onBlur, props.onFocus, {
    attributes: {
      class: (
        proseStyle === "sm" ? "prose-sm" : "prose"
      ) + " p-2 prose-zinc prose-ul:list-disc prose-ol:list-decimal grow prose-a:break-all prose-a:whitespace-pre-wrap prose-a:line-clamp-2 prose-a:overflow-hidden prose-a:inline focus-visible:outline-none"
    }
  }, props.placeholderText, toolbar === "withSingleHeadingLevel" ? [
      3,
      4
    ] : (
      toolbar === "default" ? [
          1,
          2,
          3
        ] : []
    ), undefined));
  React.useEffect(() => {
    Stdlib_Option.forEach(editorRef, fn => fn(Stdlib_Option.map(editor, e => ({
      editor: e
    }))));
  }, [
    editorRef,
    editor
  ]);
  let tmp;
  if (editor !== undefined) {
    let editor$1 = Primitive_option.valFromOption(editor);
    tmp = JsxRuntime.jsxs("div", {
      children: [
        toolbar === "withoutHeaders" || toolbar === "default" || toolbar === "withSingleHeadingLevel" ? JsxRuntime.jsx(RichTextEditorV5$Toolbar, {
            editor: editor$1,
            variant: toolbar
          }) : null,
        JsxRuntime.jsx(Tiptap.ReactTiptap.EditorContent.make, {
          editor: editor$1,
          className: "grow flex"
        })
      ],
      className: TailwindMerge.twMerge([
        "border rounded flex flex-col",
        height === "short" ? "min-h-[10rem]" : "min-h-[14rem]",
        status !== undefined ? (
            status === "ok" ? "border-tan-success" : "border-tan-error-500"
          ) : "border-zinc-200"
      ])
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          ReactRender.fromOption(props.labelText, labelText => JsxRuntime.jsx(Form__Label.make, {
            labelText: labelText,
            optionalText: optionalText,
            htmlFor: id
          })),
          ReactRender.fromOption(props.helpText, helpText => JsxRuntime.jsx(Form__HelpLabel.make, {
            children: helpText
          }))
        ]
      }),
      tmp
    ]
  });
}

let Icons;

let make$1 = RichTextEditorV5;

exports.Icons = Icons;
exports.Toolbar = Toolbar;
exports.getContent = getContent;
exports.make = make$1;
/* make Not a pure module */
